import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import classes from './QuantityPill.module.scss';

const MIN_QUANTITY = 1;

interface QuantityPillProps {
    label: string;
    value: number;
    // Lowest quantity the pill goes down to: what the booking already has for the day.
    min?: number;
    disabled?: boolean;
    onChange: (value: number) => void;
}

/** ⊖ 1 ⊕ inside a rounded pill (Figma 1930:6228). The backend sets no maximum. */
export const QuantityPill: React.FC<QuantityPillProps> = ({
    label,
    value,
    min = MIN_QUANTITY,
    disabled,
    onChange
}) => (
    <div className={classes.root} role="group" aria-label={label}>
        <button
            type="button"
            className={classes.button}
            aria-label={`Decrease ${label}`}
            disabled={disabled || value <= min}
            onClick={() => onChange(value - 1)}
        >
            <FontAwesomeIcon icon={faCircleMinus} />
        </button>

        <span className={classes.value} aria-live="polite">
            {value}
        </span>

        <button
            type="button"
            className={classes.button}
            aria-label={`Increase ${label}`}
            disabled={disabled}
            onClick={() => onChange(value + 1)}
        >
            <FontAwesomeIcon icon={faCirclePlus} />
        </button>
    </div>
);
